exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3yAl1uH2Pa4JrozPH43QSE{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:100%;height:100%}._3Z92pMI-lvVX46OAjpt2k4{position:relative;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}", ""]);

// exports
exports.locals = {
	"mainContent": "_3yAl1uH2Pa4JrozPH43QSE",
	"surfaceContainer": "_3Z92pMI-lvVX46OAjpt2k4"
};